<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="itemId ? 'Update' : 'Create'"
  >
    <template slot="header">
      <span>{{ itemId ? 'Update' : 'Create' }} Scrap Reason</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="item.name"
            :rules="[(v) => !!v || 'Scrap Reason Name is required']"
          >
            <template slot="label">
              Scrap Reason Name<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>

export default {
  data: () => ({
    item: null,
    itemId: 0,
    itemDto: {
      id: 0,
      name: '',
    },
  }),
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async get(id) {
      if (!id) return;
      this.item = await this.$api.supplyToLineScrapReason.get(id);
    },

    async submit() {
      if (!this.item) return false;
      const userId = this.$store.getters.user.id;
      if (userId) this.item.created_by = userId;

      let res;
      if (this.itemId) {
        res = await this.$api.supplyToLineScrapReason.update(this.item);
      } else {
        res = await this.$api.supplyToLineScrapReason.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$emit('success');
      return res;
    },

    open(id) {
      this.itemId = id;
      if (id) {
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
